import cnpj from "./cnpj";
import cpf from "./cpf";

const TYPES = {
    CPF: "999.999.999-999",
    CNPJ: "99.999.999/9999-99",
};
const MAX_LENGTH = clear(TYPES.CNPJ).length;


const mask = (value: string): string => {

    let v = clear(value);

    const mask = getMask(v);

    if (mask === "CPF" && !cpf.isValid(v)) {
        return "";
    } else if (mask === "CNPJ" && !cnpj.isValid(v)) {
        return "";
    }

    let nextLength = v.length;

    if (nextLength > MAX_LENGTH) return "";

    v = applyMask(v, TYPES[mask]);

    return v;
}

function getMask(value: string) {
    return value.length > 11 ? "CNPJ" : "CPF";
}

function applyMask(value: string, mask: string) {
    let result = "";

    let inc = 0;
    Array.from(value).forEach((letter, index) => {
        if (!mask[index + inc].match(/[0-9]/)) {
            result += mask[index + inc];
            inc++;
        }
        result += letter;
    });
    return result;
}

function clear(value: string) {
    return value && value.replace(/[^0-9]/g, "");
}


export default mask